/**
 * canBootstrap returns false when the window runs inside a frame.
 * main.ts then does not start Angular in that frame.
 *
 * During an SSO outage the browser loads the app document in the silent refresh iframe.
 * Without this guard the app in that frame starts the next silent refresh.
 * The browser then loads frame after frame without a limit.
 * canBootstrap stops the Angular start in each frame after the frame loads the document.
 * canBootstrap does not stop the document load.
 */
export function canBootstrap(win: Window = window): boolean {
  if (win.self === win.top) {
    return true;
  }
  // canBootstrap runs outside an Angular injection context. logger() from
  // @isa/core/logging needs that context, so canBootstrap uses console.warn.
  console.warn(
    'canBootstrap stops the app start because the app document runs inside a frame.',
  );
  return false;
}
